import React from 'react';
import { Outlet } from 'react-router-dom'; 
import Header from './Header';
import Sidebar from './Sidebar';

export default function Layout() {
  return (
    <div className="yc-app">
      <Header />
      <div className="yc-body">
        <Sidebar />
        <main className="yc-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}